import { FontFamilyInfo, FontType } from './FontFamilyInfo';

const font = (name: string, label: string, type: FontType, source: string): FontFamilyInfo =>
    ({ name, label, type, source });
const googleFont = (name: string, type: FontType, label?: string) =>
    font(name, label ?? name, type, 'google');
const systemFont = (name: string, type: FontType, label?: string) =>
    font(name, label ?? name, type, 'system');

const list = (...x: FontFamilyInfo[]) => x.slice().sort((a, b) => a.label.localeCompare(b.label));

export const SerifFontList = list(
    systemFont('Times New Roman', 'serif'),
    systemFont('Palatino', 'serif'),
    googleFont('Bitter', 'serif'),
    googleFont('Gentium Book Plus', 'serif'),
    googleFont('Lora', 'serif'),
    googleFont('Merriweather', 'serif'),
);

export const SansFontList = list(
    systemFont('Helvetica', 'sans', 'Arial / Helvetica'),
    systemFont('Courier New', 'sans'),
    googleFont('Barlow', 'sans'),
    googleFont('Cabin', 'sans'),
    googleFont('Dosis', 'sans'),
    googleFont('Fira Mono', 'sans'),
    googleFont('Fira Sans', 'sans'),
    googleFont('Hind', 'sans'),
    googleFont('Inter', 'sans'),
    googleFont('Kanit', 'sans'),
    googleFont('Lato', 'sans'),
    googleFont('Montserrat', 'sans'),
    googleFont('Open Sans', 'sans'),
    googleFont('Oxygen', 'sans'),
    googleFont('Quicksand', 'sans'),
    googleFont('Raleway', 'sans'),
    googleFont('Roboto Condensed', 'sans'),
    googleFont('Roboto', 'sans'),
    googleFont('Rubik', 'sans'),
    googleFont('Ubuntu', 'sans'),
);

export const HandwritingFontList = list(
    googleFont('Architects Daughter', 'handwriting'),
    googleFont('Coming Soon', 'handwriting'),
    googleFont('Dekko', 'handwriting'),
    googleFont('Delius', 'handwriting'),
    googleFont('Handlee', 'handwriting'),
    googleFont('Itim', 'handwriting'),
    googleFont('Kalam', 'handwriting'),
    googleFont('Kavivanar', 'handwriting'),
    googleFont('Mali', 'handwriting'),
    googleFont('Merienda', 'handwriting'),
    googleFont('Neucha', 'handwriting'),
    googleFont('Patrick Hand', 'handwriting'),
    googleFont('Short Stack', 'handwriting'),
    googleFont('Swanky and Moo Moo', 'handwriting'),
    googleFont('Tillana', 'handwriting'),
    googleFont('Walter Turncoat', 'handwriting'),
);

export const InAppFontList = list(
    ...SansFontList,
    ...SerifFontList,
    ...HandwritingFontList,
);
